import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Plus } from "lucide-react";
import { EASE, Reveal, Kicker } from "./Reveal";
import { FAQS } from "../data/content";

export const Faq = () => {
  const [open, setOpen] = useState(0);

  return (
    <div data-testid="faq-section">
      <Reveal>
        <Kicker>Häufige Fragen</Kicker>
      </Reveal>
      <Reveal delay={0.08}>
        <h3 data-testid="faq-title" className="font-display text-3xl md:text-4xl font-semibold tracking-tight text-ink mt-4 mb-8">
          Antworten, bevor Sie <span className="font-fraktur text-golddark">fragen müssen.</span>
        </h3>
      </Reveal>
      <div className="max-w-4xl">
        {FAQS.map((f, i) => {
          const isOpen = open === i;
          return (
            <Reveal key={f.q} delay={i * 0.05} y={20}>
              <div className="border-t border-line last:border-b">
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  data-testid={`faq-trigger-${i}`}
                  aria-expanded={isOpen}
                  className="w-full flex items-center justify-between gap-6 py-6 text-left group"
                >
                  <span className="font-display text-lg md:text-xl font-semibold tracking-tight text-ink group-hover:text-golddark transition-colors duration-300">
                    {f.q}
                  </span>
                  <motion.span
                    animate={{ rotate: isOpen ? 45 : 0 }}
                    transition={{ duration: 0.3, ease: EASE }}
                    className="shrink-0 w-9 h-9 border border-line flex items-center justify-center text-golddark"
                  >
                    <Plus size={16} />
                  </motion.span>
                </button>
                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.4, ease: EASE }}
                      className="overflow-hidden"
                    >
                      <p className="text-muted leading-relaxed pb-6 max-w-2xl" data-testid={`faq-panel-${i}`}>
                        {f.a}
                      </p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  );
};
